import { useContext } from 'react'
import Button from '../../../core/Button/Button'
import { Spacer } from '../../../core/Components'
import { ConditionalWrapper } from '../../../core/ConditionalWrapper'
import { ModalComponents } from '../../../core/Modal'
import { LoadingStatus } from '../../activitybar/sample-packs/SamplePackDropdown'
import { Page } from './hooks/useRegisterSongModal'
import { RegisterModalContext } from './RegisterSongModal'

const ButtonTextMap = {
  [Page.DETAILS]: 'Confirm Registration',
  [Page.ATTRIBUTIONS]: 'Confirm Attribution & Publish Song',
  [Page.CONFIRMATION]: 'View song details'
}

export const Navigation = () => {
  const { state, nextPage, isLastPage, isFirstPage, previousPage, isNextPageAllowed } =
    useContext(RegisterModalContext)

  return (
    <ModalComponents.FooterContainer>
      {!isLastPage && (
        <Button big modalButton type="outlined" onClick={previousPage} disabled={isFirstPage}>
          Back
        </Button>
      )}
      <Spacer />
      <ConditionalWrapper
        condition={isLastPage}
        wrapper={(children) => (
          <a
            href={`${window.location.origin}/song-preview/${state.createdMintStatus?.jobId}`}
            target="_blank"
          >
            {children}
          </a>
        )}
      >
        {state.page === Page.UPLOAD_PROJECT && state.projectFileField.value === undefined && (
          <Button type="outlined" big modalButton onClick={nextPage} css={{ marginRight: '8px' }}>
            Skip
          </Button>
        )}
        <Button
          big
          modalButton
          disabled={
            (!isNextPageAllowed && !isLastPage) ||
            state.mintingStatus === LoadingStatus.ERROR ||
            state.mintingStatus === LoadingStatus.LOADING
          }
          onClick={isLastPage ? null : nextPage}
          css={{
            backgroundColor: '#7266F9',
            color: 'white'
          }}
        >
          {ButtonTextMap[state.page] || 'Continue'}
        </Button>
      </ConditionalWrapper>
    </ModalComponents.FooterContainer>
  )
}
